const userStatus = [
  { id: 'ACTIVE', name: 'Active' },
  { id: 'INVITED', name: 'Invited' },
  { id: 'SUSPENDED', name: 'Suspended' },
  { id: 'OFFLINE', name: 'Offline' }
];

// the pair 'value - label' is used by react-admin <SelectInput />
// the pair 'id - name' is used by mui-rff <Select />

const userTypeForIA = [
  {
    value: 'REGULAR_CONTACT',
    label: 'Regular Contact',
    id: 'REGULAR_CONTACT',
    name: 'Regular Contact'
  },
  {
    value: 'INVESTOR_ADMIN',
    label: 'Investor Admin',
    id: 'INVESTOR_ADMIN',
    name: 'Investor Admin'
  }
];

const userType = [
  {
    value: 'FUND_ADMIN',
    label: 'Fund Admin',
    id: 'FUND_ADMIN',
    name: 'Fund Admin'
  },
  ...userTypeForIA
];

const userTypeSA = [
  {
    value: 'SUPER_ADMIN',
    label: 'Super Admin',
    id: 'SUPER_ADMIN',
    name: 'Super Admin'
  },
  ...userType
];

export { userStatus, userTypeForIA, userType, userTypeSA };
